import { render, staticRenderFns } from "./contact-list.vue?vue&type=template&id=0db206e7&scoped=true"
import script from "./contact-list.vue?vue&type=script&lang=js"
export * from "./contact-list.vue?vue&type=script&lang=js"
import style0 from "./contact-list.vue?vue&type=style&index=0&id=0db206e7&prod&lang=less&scoped=true"
import style1 from "./contact-list.vue?vue&type=style&index=1&id=0db206e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db206e7",
  null
  
)

export default component.exports